import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class InvalidUserException extends LicenseException
{

}
